import { format, parseISO } from "date-fns";
import { DropdownSelectOption, Icon, IconButton, Typography } from "@/components/atoms";
import { DataTableColumnDef } from "@/components/molecules";
import { PastReceipt } from "@/redux/apis/clientReceipts/types";
import { getOrdinalNumber } from "@/utils";

export type ReceiptsTableData = {
  date: JSX.Element;
  action: JSX.Element;
};

// 1–28 only: a day that exists in every month (mirrors mobile)
export const RECEIPT_CYCLE_OPTIONS: DropdownSelectOption[] = Array.from({ length: 28 }, (_, i) => ({
  name: `Every ${getOrdinalNumber(i + 1)} of the month`,
  value: String(i + 1),
}));

/** "2026-05-01" -> "May 2026" (month label per Figma) */
export const formatReceiptMonth = (monthStart: string) => format(parseISO(monthStart), "MMM yyyy");

export const generateReceiptsTableData = (
  receipts: PastReceipt[],
  onDownload: (receipt: PastReceipt) => void,
  downloadingId: string | null
): ReceiptsTableData[] =>
  receipts.map((receipt) => ({
    date: (
      <div className="flex items-center gap-2">
        <Icon name="file-pdf-color" isCustom size="lg" className="shrink-0" />
        <Typography variant="paragraph" className="text-neutral-black">
          {formatReceiptMonth(receipt.monthStart)}
        </Typography>
      </div>
    ),
    action: (
      <IconButton
        variant="custom"
        iconSize="lg"
        isCustomIcon
        iconName="download-tray"
        className="text-neutral-dark-gray"
        aria-label={`Download ${formatReceiptMonth(receipt.monthStart)} receipt`}
        disabled={downloadingId === receipt.id}
        onClick={() => onDownload(receipt)}
      />
    ),
  }));

export const receiptsColumns: DataTableColumnDef<ReceiptsTableData>[] = [
  { accessorKey: "date", header: "Date", id: "date", cell: (props) => props.row.original.date, enableSorting: false },
  { accessorKey: "action", header: "Action", id: "action", cell: (props) => props.row.original.action, size: 75, enableSorting: false },
];
